module.exports = __webpack_public_path__ + "img/menu.e5c5c210.svg";